import PropTypes from 'prop-types'
import React from 'react'
import { UserAvatar } from 'components/UserAvatar'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'

function UserRowAvatar ({ size, value }) {
  return (
    <UserAvatar
      size={size}
      value={value}
      style={{
        marginRight: STYLES_MARGIN.SMALL
      }}
    />
  )
}

UserRowAvatar.SIZE = UserAvatar.SIZE
UserRowAvatar.defaultProps = {
  size: UserAvatar.SIZE.BIGGEST
}
UserRowAvatar.propTypes = {
  value: PropTypes.string,
  size: PropTypes.oneOf(
    Object.values(UserRowAvatar.SIZE)
  )
}
export default UserRowAvatar
